import { graphql } from "../gql";

export const createSsoDomainIdentityProviderMutationDoc = graphql(`
  mutation createSsoDomainIdentityProvider(
    $input: CreateSsoDomainIdentityProviderInput!
  ) {
    createSsoDomainIdentityProvider(input: $input) {
      ssoDomainIdentityProvider {
        id
        domain
        environment
        tenantId
        config
        isActive
        updatedAt
        __typename
      }
    }
  }
`);
